import React from "react";
import { Badge } from "@/components/ui/badge";
import { Star } from "lucide-react";

interface GibRatingBadgeProps {
  rating: number;
  className?: string;
}

const GibRatingBadge: React.FC<GibRatingBadgeProps> = ({ rating, className = "" }) => {
  const displayRating = rating.toFixed(1);
  
  return (
    <Badge 
      variant="outline"
      className={`bg-gradient-to-r from-indigo-50 to-violet-50 text-indigo-700 border-indigo-300 font-medium ${className}`}
    >
      <Star className="h-3 w-3 mr-1 fill-indigo-400 text-indigo-400" />
      {displayRating}
    </Badge>
  );
};

export default GibRatingBadge;
